import { onDomReady } from 'Shared/utils/dom-ready';

onDomReady(() => {
   const button = document.querySelector('#js-iso-language-dropdown-button');
   if (!button) {
      return;
   }

   window.languageDropdownButton.setProps({
      translationPreferencesUrl: App.translationPreferencesUrl,
      languages: App.languages,
   });
   window.languageDropdownButton.setRenderTarget(document.querySelector('#js-iso-lang-dropdown'));

   window.languageDropdownButton.renderDropdown();
   button.addEventListener('click', window.languageDropdownButton.toggle);
});
